import { Field, useFormikContext } from "formik";
import { useState } from "react";
import { Input } from "../../Form/Input/Input";
import { Tab } from "../../UI/Tabs/Tab";
import { TabPanel } from "../../UI/Tabs/TabPanel";
import { FormDescription } from "../../Form/FormDescription/FormDescription";
import styles from "./Consent.module.scss";

export const Consent = () => {
  const [tabValue, setTabValue] = useState(0);
  const { setFieldValue } = useFormikContext();

  const clickHandler = (index) => {
    setTabValue(index);
    setImageFile(null);
  };

  const fileChangeHandler = (event) => {
    const files = event.currentTarget.files;
    const imageFile = files && files[0];
    if (!imageFile) {
      return;
    }
    setImageFile(imageFile);
  };

  const setImageFile = (imageFile) => {
    setFieldValue("consentImage.file", imageFile);
    setFieldValue("consentImageFile", imageFile); // Only for validation
  };

  return (
    <>
      <div className={styles.tabs}>
        <Tab value={tabValue} index={0} onClick={clickHandler}>
          Online form
        </Tab>
        <Tab value={tabValue} index={1} onClick={clickHandler}>
          Paper form
        </Tab>
      </div>
      <TabPanel value={tabValue} index={0}>
        <Field
          name="consentName"
          as={Input}
          placeholder="Patient's full name"
        />
        <FormDescription>
          If your patient have signed the online consent form, then it is
          already uploaded to PlastSurgeon. Just write the name of the patient
          and we will match up your case with the consent of your patient.
        </FormDescription>
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <input
          type="file"
          className={styles.fileInput}
          onChange={fileChangeHandler}
          accept="image/png, image/jpeg"
        />
        <FormDescription>
          If your patient have signed a paper version of the consent form, then
          upload a photo of it.
        </FormDescription>
      </TabPanel>
    </>
  );
};
